import { api } from '../configs/axiosConfigs';

export const getEstimatedRepairCosts = async (propertyId: string) => {
  return await api.get(`/properties/${propertyId}/fixed-costs`);
};